import { useMemo } from 'react'
import { CheckGroup } from '../api'
import { useDokumententresorCryptoSubtle } from './dokumententresor_cryptsubtle'
import { useDokumententresorEnd2End } from './dokumententresor_end2end'
import { useDokumententresorSessionStorage } from './dokumententresor_sessionstorage'

type EncryptionConfig = {
    name: string
    modulusLength: number
    publicExponent: Uint8Array
    hash: string
}

export const useDokumententresorEncryptionConfig = (): EncryptionConfig => {
    return useMemo(
        () => ({
            name: 'RSA-OAEP',
            modulusLength: 2048,
            publicExponent: new Uint8Array([1, 0, 1]),
            hash: 'SHA-256',
        }),
        []
    )
}

export const useDokumententresorChecks = (): CheckGroup => {
    const dokumententresorCryptoSubtle = useDokumententresorCryptoSubtle()
    const dokumententresorSessionStorage = useDokumententresorSessionStorage()
    const dokumententresorEnd2End = useDokumententresorEnd2End()

    return {
        name: 'Dokumententresor',
        checks: [dokumententresorCryptoSubtle, dokumententresorSessionStorage, dokumententresorEnd2End],
    }
}
